import { render, staticRenderFns } from "./accidentReportCreate.vue?vue&type=template&id=c1c8e2ba&scoped=true"
import script from "./accidentReportCreate.vue?vue&type=script&lang=js"
export * from "./accidentReportCreate.vue?vue&type=script&lang=js"
import style0 from "./accidentReportCreate.vue?vue&type=style&index=0&id=c1c8e2ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c8e2ba",
  null
  
)

export default component.exports